module.exports = __webpack_public_path__ + "img/banner.3fd2a62f.jpeg";